import { render } from "./BlogCategoriesStyle.vue?vue&type=template&id=04314e8c&scoped=true"
import script from "./BlogCategoriesStyle.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesStyle.vue?vue&type=script&lang=js"

import "./BlogCategoriesStyle.vue?vue&type=style&index=0&id=04314e8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04314e8c"

export default script